PJQ.constants.integrations = {
    settings: {
        SYNC_PROJECTS: 'syncProjects',
        SYNC_VENDORS: 'syncVendors',
        SYNC_SUB_JOBS: 'syncSubJobs',
        SYNC_BUDGET: 'syncBudget',
        SYNC_DIRECT_COSTS: 'syncDirectCosts',
        SYNC_COMMITMENTS: 'syncCommitments',
        SYNC_COMMITMENT_CHANGE_ORDERS: 'syncCommitmentChangeOrders',
        SYNC_PRIME_CONTRACTS: 'syncPrimeContracts',
        SYNC_PRIME_CONTRACT_CHANGE_ORDERS: 'syncPrimeContractChangeOrders',
        SYNC_PAYABLE_INVOICES: 'syncPayableInvoices',
        SYNC_RECEIVABLE_INVOICES: 'syncReceivableInvoices'
    },
    actions: {
        CAN_ADD_MARKUPS_AFTER_SYNC: 'CAN_ADD_MARKUPS_AFTER_SYNC',
        PUSH_VENDORS: 'PUSH_VENDORS',
        UNLINK_VENDOR: 'UNLINK_VENDOR',
        PUSH_PROJECT: 'PUSH_PROJECT',
        LINK_PROJECT: 'LINK_PROJECT',
        UNLINK_PROJECT: 'UNLINK_PROJECT',
        PROJECT_SPECIFIC_COST_CODES: 'PROJECT_SPECIFIC_COST_CODES',
        PUSH_SUB_JOBS: 'PUSH_SUB_JOBS',
        PULL_SUB_JOBS: 'PULL_SUB_JOBS',
        PUSH_COMPANY_COST_CODES: 'PUSH_COMPANY_COST_CODES',
        PULL_COMPANY_COST_CODES: 'PULL_COMPANY_COST_CODES',
        PUSH_PROJECT_COST_CODES: 'PUSH_PROJECT_COST_CODES',
        PULL_PROJECT_COST_CODES: 'PULL_PROJECT_COST_CODES',
        PUSH_COMPANY_TAX_CODES: 'PUSH_COMPANY_TAX_CODES',
        PULL_COMPANY_TAX_CODES: 'PULL_COMPANY_TAX_CODES',
        PUSH_COST_TYPES: 'PUSH_COST_TYPES',
        PULL_COST_TYPES: 'PULL_COST_TYPES',
        PUSH_BUDGET: 'PUSH_BUDGET',
        PULL_BUDGET: 'PULL_BUDGET',
        PUSH_COMMITMENTS: 'PUSH_COMMITMENTS',
        PUSH_COMMITMENTS_WITH_VENDOR: 'PUSH_COMMITMENTS_WITH_VENDOR',
        PULL_COMMITMENTS: 'PULL_COMMITMENTS',
        PULL_COMMITMENTS_DOC_CLERK_REQUIRED: 'PULL_COMMITMENTS_DOC_CLERK_REQUIRED',
        UNLINK_COMMITMENTS: 'UNLINK_COMMITMENTS',
        PUSH_COMMITMENT_CHANGE_ORDERS: 'PUSH_COMMITMENT_CHANGE_ORDERS',
        PULL_COMMITMENT_CHANGE_ORDERS: 'PULL_COMMITMENT_CHANGE_ORDERS',
        COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV: 'COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV',
        UNLINK_COMMITMENT_CHANGE_ORDERS: 'UNLINK_COMMITMENT_CHANGE_ORDERS',
        PUSH_CHANGE_REQUESTS: 'PUSH_CHANGE_REQUESTS',
        PUSH_PRIME_CONTRACTS: 'PUSH_PRIME_CONTRACTS',
        PUSH_PRIME_CONTRACTS_WITH_CLIENT: 'PUSH_PRIME_CONTRACTS_WITH_CLIENT',
        PULL_PRIME_CONTRACTS: 'PULL_PRIME_CONTRACTS',
        PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED: 'PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED',
        UNLINK_PRIME_CONTRACTS: 'UNLINK_PRIME_CONTRACTS',
        PUSH_PRIME_CONTRACT_CHANGE_ORDERS: 'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
        PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT: 'PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT',
        PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO: 'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
        PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED: 'PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED',
        UNLINK_PRIME_CONTRACT_CHANGE_ORDERS: 'UNLINK_PRIME_CONTRACT_CHANGE_ORDERS',
        PUSH_DIRECT_COSTS: 'PUSH_DIRECT_COSTS',
        PULL_DIRECT_COSTS: 'PULL_DIRECT_COSTS',
        UNLINK_DIRECT_COSTS: 'UNLINK_DIRECT_COSTS',
        PUSH_PAYABLE_INVOICES: 'PUSH_PAYABLE_INVOICES',
        PUSH_PAYABLE_INVOICES_WO_SYNCED_COMMMITMENT: 'PUSH_PAYABLE_INVOICES_WO_SYNCED_COMMMITMENT',
        PULL_PAYABLE_INVOICES: 'PULL_PAYABLE_INVOICES',
        PULL_RECEIVABLE_PAYMENTS: 'PULL_RECEIVABLE_PAYMENTS',
        PULL_PAYABLE_PAYMENTS: 'PULL_PAYABLE_PAYMENTS',
        UNLINK_PAYABLE_INVOICES: 'UNLINK_PAYABLE_INVOICES',
        REQUIRE_SYNCED_COST_TYPES: 'REQUIRE_SYNCED_COST_TYPES',
        REQUIRE_SYNCED_COST_CODES: 'REQUIRE_SYNCED_COST_CODES',
        PUSH_RECEIVABLE_INVOICES: 'PUSH_RECEIVABLE_INVOICES',
        PUSH_RECEIVABLE_INVOICES_WO_SYNCED_CONTRACT: 'PUSH_RECEIVABLE_INVOICES_WO_SYNCED_CONTRACT',
        PULL_RECEIVABLE_INVOICES: 'PULL_RECEIVABLE_INVOICES',
        UNLINK_RECEIVABLE_INVOICES: 'UNLINK_RECEIVABLE_INVOICES',
        CREATE_TAX_CODES: 'CREATE_TAX_CODES',
        DISABLE_EDIT_COST_CODE_TYPE_FILTER: 'DISABLE_EDIT_COST_CODE_TYPE_FILTER',
        RELATE_CCO_LINE_TO_COMMITMENT_LINE: 'RELATE_CCO_LINE_TO_COMMITMENT_LINE',
    },
    providers: {
        ACUMATICA: {
            logoURL: '/assets/modules2/global/images/acumatica.png',
            name: 'ACUMATICA',
            shortName: 'Acumatica',
            displayName: 'Acumatica Cloud ERP',
            description: 'Integrate Acumatica Cloud ERP to work with your job costing tools',
            supportedVersions: [
                '24.200.001',
                '23.200.001',
                '22.200.001',
            ],
            availableActions: [
                'PUSH_VENDORS',
                'UNLINK_VENDOR',
                'PUSH_PROJECT',
                'LINK_PROJECT',
                'UNLINK_PROJECT',
                'PULL_COMPANY_COST_CODES',
                'PULL_PROJECT_COST_CODES',
                'PUSH_SUB_JOBS',
                'PULL_SUB_JOBS',
                'PUSH_BUDGET',
                'PULL_BUDGET',
                'PUSH_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACTS_WITH_CLIENT',
                'UNLINK_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'UNLINK_PRIME_CONTRACT_CHANGE_ORDERS',
                'PULL_DIRECT_COSTS',
                'UNLINK_DIRECT_COSTS',
                'PUSH_COMMITMENTS',
                'UNLINK_COMMITMENTS',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'UNLINK_COMMITMENT_CHANGE_ORDERS',
                'PUSH_PAYABLE_INVOICES',
                'UNLINK_PAYABLE_INVOICES',
                'CREATE_TAX_CODES',
                'PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT',
                'PUSH_RECEIVABLE_INVOICES',
                'UNLINK_RECEIVABLE_INVOICES',
                'RELATE_CCO_LINE_TO_COMMITMENT_LINE'
            ],
            options: {
                linkProjectAlert: 'Linking to existing Jobs within Acumatica that have existing transactions is not supported. This may cause discrepancies in your Job Costing data.'
            },
            budgetColumns: [
                {
                    name: 'Revised Budgeted Amount',
                    source: 'erp:rev_b_amt',
                    canCalculate: true,
                    format: 'money',
                    isErp: true
                },
                {
                    name: 'Revised Budgeted Quantity',
                    source: 'erp:rev_b_qty',
                    canCalculate: true,
                    format: 'decimal',
                    isErp: true
                },
                {
                    name: 'Budgeted CO Amount',
                    source: 'erp:b_co_amt',
                    canCalculate: true,
                    format: 'money',
                    isErp: true
                },
                {
                    name: 'Budgeted CO Quantity',
                    source: 'erp:b_co_qty',
                    canCalculate: true,
                    format: 'decimal',
                    isErp: true
                },
                {
                    name: 'Pending Invoice Amount',
                    source: 'erp:pnd_inv_amt',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Committed Invoiced Amount',
                    source: 'erp:cm_inv_amt',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Actual Amount',
                    source: 'erp:act_amt',
                    canCalculate: true,
                    format: 'money'
                },
            ],
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'project',
                        displayName: "Projects",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Project ID',
                                value: 'projectID',
                                required: true,
                                className: 'input-project-id'
                            }
                        ]
                    },
                    subjob: {
                        internalModelName: 'subjob',
                        externalModelName: 'subjob',
                        displayName: "Sub Jobs",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        }
                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Vendor ID',
                                value: 'externalNumber',
                                required: true,
                                format: '#{0,10}',
                                className: 'input-vendor-number'
                            }
                        ]
                    },
                    costcode: {
                        internalModelName: 'costcode',
                        externalModelName: 'costcode',
                        displayName: "Cost Codes",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        }
                    },
                    budget: {
                        internalModelName: 'budget',
                        displayName: "Budget",
                        externalModelName: 'costbudget',
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    contract: {
                        internalModelName: 'contract',
                        externalModelName: 'contract',
                        displayName: "Contracts",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        }
                    },
                    ar_inv: {
                        internalModelName: 'ar_inv',
                        externalModelName: 'ar_inv',
                        displayName: "Receivable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'co_commitment',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    }
                }
            }
        },
        QBO: {
            logoURL: '/assets/modules2/global/images/QBO_logo.svg',
            buttonClass: 'btn-qbo-connect',
            name: 'QBO',
            shortName: 'QuickBooks',
            buttonText: 'Connect to QuickBooks',
            displayName: 'QuickBooks Online',
            description: 'Integrate QuickBooks Online to work with your job costing tools',
            availableActions: [
                'UNLINK_PROJECT',
                'PUSH_VENDORS',
                'PROJECT_SPECIFIC_COST_CODES',
                'PUSH_COMPANY_COST_CODES',
                'PUSH_PROJECT_COST_CODES',
                'PUSH_COST_TYPES',
                'PULL_COST_TYPES',
                'PUSH_COMMITMENTS',
                'PUSH_COMMITMENTS_WITH_VENDOR',
                'UNLINK_COMMITMENTS',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'UNLINK_COMMITMENT_CHANGE_ORDERS',
                'PUSH_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACTS_WITH_CLIENT',
                'UNLINK_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'UNLINK_PRIME_CONTRACT_CHANGE_ORDERS',
                'PULL_BUDGET',
                'PULL_DIRECT_COSTS',
                'PUSH_DIRECT_COSTS',
                'UNLINK_DIRECT_COSTS',
                'PUSH_PAYABLE_INVOICES',
                'PUSH_PAYABLE_INVOICES_WO_SYNCED_COMMMITMENT',
                'UNLINK_PAYABLE_INVOICES',
                'PUSH_RECEIVABLE_INVOICES',
                'PUSH_RECEIVABLE_INVOICES_WO_SYNCED_CONTRACT',
                'UNLINK_RECEIVABLE_INVOICES',
                'PULL_COMPANY_TAX_CODES',
                'LINK_PROJECT'
            ],
            options: {
                linkProjectAlert: 'QuickBooks Online limits 3rd party visibility to the last <strong>30 days</strong> of expenses. It is strongly recommended that you do not link to a project which has expenses older than this to avoid inconsistencies.'
            },
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'project',
                        displayName: "Projects",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: []
                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: []
                    },
                    contract: {
                        internalModelName: 'contract',
                        externalModelName: 'contract',
                        displayName: "Contracts",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    ar_inv: {
                        internalModelName: 'ar_inv',
                        externalModelName: 'ar_inv',
                        displayName: "Receivable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'cco',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    d_cost: {
                        internalModelName: 'd_cost',
                        externalModelName: 'd_cost',
                        displayName: "Direct Costs",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    }
                }
            }
        },
        SAGE100: {
            logoURL: '/assets/modules2/global/images/sage100.png',
            name: 'SAGE100',
            shortName: 'Sage 100',
            displayName: 'Sage 100 Contractor',
            description: 'Integrate Sage 100 Contractor to work with your job costing tools',
            availableActions: [
                'PUSH_VENDORS',
                'PUSH_PROJECT',
                'PULL_COMPANY_COST_CODES',
                'PUSH_PROJECT_COST_CODES',
                'PULL_PROJECT_COST_CODES',
                'PULL_COMPANY_TAX_CODES',
                'PULL_SUB_JOBS',
                'PUSH_BUDGET',
                'PULL_BUDGET',
                'PUSH_COMMITMENTS',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'PULL_DIRECT_COSTS',
                'PUSH_PAYABLE_INVOICES',
                'REQUIRE_SYNCED_COST_TYPES',
                'PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PULL_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
            ],
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'job',
                        displayName: "Jobs",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '9{0,8}',
                                className: 'input-project-code'
                            }
                        ]

                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '9{0,10}',
                                className: 'input-vendor-number'
                            }
                        ]
                    },
                    costcode: {
                        internalModelName: 'costcode',
                        externalModelName: 'costcode',
                        displayName: "Cost Codes",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        }
                    },
                    budget: {
                        internalModelName: 'budget',
                        displayName: "Budget",
                        externalModelName: 'estimate',
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                // format: '99999',
                                format: '#{0,20}',
                                className: 'input-commitment-number'
                            }
                        ]
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'cco',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                // format: '9999',
                                format: '#{0,20}',
                                required: true,
                                className: 'input-cco-number'
                            }
                        ]
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '*{0,5}',
                                className: 'input-payable-invoice-number'
                            },
                            {
                                type: 'date',
                                name: 'Approval Date',
                                value: 'approvalDate',
                                required: false,
                                className: 'input-payable-invoice-approval-date'
                            }
                        ]
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '9999',
                                className: 'input-pcco-number'
                            }
                        ]
                    },
                }
            }
        },
        SAGE300: {
            logoURL: '/assets/modules2/global/images/sage300.png',
            name: 'SAGE300',
            shortName: 'Sage 300',
            displayName: 'Sage 300',
            description: 'Integrate Sage 300 CRE to work with your job costing tools',
            availableActions: [
                'PUSH_VENDORS',
                'PUSH_PROJECT',
                'LINK_PROJECT',
                'PULL_COMPANY_COST_CODES',
                'PUSH_PROJECT_COST_CODES',
                'PULL_PROJECT_COST_CODES',
                'PULL_COST_TYPES',
                'PULL_COMPANY_TAX_CODES',
                'PUSH_SUB_JOBS',
                'PULL_SUB_JOBS',
                'PUSH_BUDGET',
                'PULL_BUDGET',
                'PUSH_COMMITMENTS',
                'PULL_COMMITMENTS',
                'PULL_COMMITMENTS_DOC_CLERK_REQUIRED',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'PULL_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'PULL_DIRECT_COSTS',
                'PUSH_PAYABLE_INVOICES',
                'REQUIRE_SYNCED_COST_TYPES',
                'CAN_ADD_MARKUPS_AFTER_SYNC',
                'PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
                'PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED',
                // 'COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV'
            ],
            options: {
                linkProjectAlert: 'Linking to existing Jobs within Sage 300 that have existing Job Costs transactions is not supported. This may cause discrepancies in your Job Costing data.'
            },
            budgetColumns: [
                {
                    name: 'Original Commitment',
                    source: 'erp:originalCommitment',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Approved Commitment Changes',
                    source: 'erp:approvedCommitmentChanges',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Revised Commitment',
                    source: 'erp:revisedCommitment',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Commitment Invoiced',
                    source: 'erp:commitmentInvoiced',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Job to Date Cost',
                    source: 'erp:jobToDateCost',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Job to Date Units',
                    source: 'erp:jobToDateUnits',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Job to Date Dollars Paid',
                    source: 'erp:jobToDateDollarsPaid',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Month to Date Cost',
                    source: 'erp:monthToDateCost',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Month to Date Units',
                    source: 'erp:monthToDateUnits',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Month to Date Dollars Paid',
                    source: 'erp:monthToDateDollarsPaid',
                    canCalculate: true,
                    format: 'money'
                }
            ],
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'job',
                        displayName: "Jobs",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '99-999',
                                className: 'input-project-code'
                            }
                        ]

                    },
                    subjob: {
                        internalModelName: 'subjob',
                        externalModelName: 'subjob',
                        displayName: "Sub Jobs",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '99999',
                                className: 'input-subjob-number'
                            }
                        ]
                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '#{0,10}',
                                className: 'input-vendor-number'
                            }
                        ]
                    },
                    costcode: {
                        internalModelName: 'costcode',
                        externalModelName: 'costcode',
                        displayName: "Cost Codes",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        }
                    },
                    budget: {
                        internalModelName: 'budget',
                        displayName: "Budget",
                        externalModelName: 'estimate',
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '9999',
                                className: 'input-pcco-number'
                            }
                        ]
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                className: 'input-commitment-number'
                            }
                        ]
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'cco',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                format: '9999',
                                required: true,
                                className: 'input-cco-number'
                            }
                        ]
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '*{0,5}',
                                className: 'input-payable-invoice-number'
                            },
                            {
                                type: 'date',
                                name: 'Approval Date',
                                value: 'approvalDate',
                                required: false,
                                className: 'input-payable-invoice-approval-date'
                            }
                        ]
                    },
                }
            }
        },
        INTACCT: {
            logoURL: '/assets/modules2/global/images/sageintacct.png',
            name: 'INTACCT',
            shortName: 'Sage Intacct',
            displayName: 'Sage Intacct',
            description: 'Integrate Sage Intacct CRE to work with your job costing tools',
            availableActions: [
                'PUSH_VENDORS',
                'UNLINK_VENDOR',
                'PUSH_PROJECT',
                'UNLINK_PROJECT',
                'PULL_COMPANY_COST_CODES',
                'PULL_PROJECT_COST_CODES',
                'PUSH_PROJECT_COST_CODES',
                'PUSH_SUB_JOBS',
                'PULL_SUB_JOBS',
                'PUSH_BUDGET',
                'PULL_BUDGET',
                'PUSH_COMMITMENTS',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'PULL_PRIME_CONTRACTS',
                'PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'PUSH_PAYABLE_INVOICES',
                'PULL_PAYABLE_PAYMENTS',
                'UNLINK_PRIME_CONTRACTS',
                'UNLINK_PRIME_CONTRACT_CHANGE_ORDERS',
                'UNLINK_COMMITMENT_CHANGE_ORDERS',
                'UNLINK_PAYABLE_INVOICES',
                'UNLINK_COMMITMENTS',
                'DISABLE_EDIT_COST_CODE_TYPE_FILTER',
                'PULL_DIRECT_COSTS'
            ],
            budgetColumns: [],
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'project',
                        displayName: "Projects",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Project ID',
                                value: 'id',
                                required: true,
                                format: '#{0,20}',
                                className: 'input-project-code'
                            }
                        ]

                    },
                    subjob: {
                        internalModelName: 'subjob',
                        externalModelName: 'subjob',
                        displayName: "Sub Jobs",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: false,
                                format: '#{0,10}',
                                className: 'input-vendor-number'
                            }
                        ]
                    },
                    costcode: {
                        internalModelName: 'costcode',
                        externalModelName: 'costcode',
                        displayName: "Cost Codes",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        }
                    },
                    budget: {
                        internalModelName: 'budget',
                        displayName: "Budget",
                        externalModelName: 'estimate',
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Project Change Order ID',
                                value: 'projectChangeOrderId',
                                required: true,
                                format: '#{0,20}',
                                className: 'input-pcco-number'
                            }
                        ]
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'cco',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    }
                }
            }
        },
        // VIEWPOINT_VISTA: {
        //     logoURL: '/assets/modules2/global/images/viewpoint_vista.png',
        //     name: 'VIEWPOINT_VISTA',
        //     displayName: 'Viewpoint Vista',
        //     description: 'Integrate Viewpoint Vista to work with your job costing tools',
        //     isAgave: true,
        //     agaveSourceSystem: 'vista-hosted',
        //     availableActions: [
        //         'PUSH_VENDORS',
        //         'PUSH_PROJECT',
        //         'PULL_COMPANY_COST_CODES',
        //         'PUSH_PROJECT_COST_CODES',
        //         'PULL_PROJECT_COST_CODES',
        //         'PULL_COMPANY_TAX_CODES',
        //         'PUSH_SUB_JOBS',
        //         'PULL_SUB_JOBS',
        //         'PUSH_BUDGET',
        //         'PULL_BUDGET',
        //         'PUSH_COMMITMENTS',
        //         'PUSH_COMMITMENT_CHANGE_ORDERS',
        //         'PULL_PRIME_CONTRACTS',
        //         'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
        //         'PULL_DIRECT_COSTS',
        //         'PUSH_PAYABLE_INVOICES',
        //         'REQUIRE_SYNCED_COST_TYPES',
        //         'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
        //         'COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV'
        //     ],
        //     erpAdmin: {
        //         features: {
        //             project: {
        //                 internalModelName: 'project',
        //                 externalModelName: 'job',
        //                 refreshType: 'projects',
        //                 displayName: "Jobs",
        //                 filters: {
        //                     readyToImport: {
        //                         displayName: 'Ready to Import',
        //                         name: 'readyToImport',
        //                     },
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '99-999',
        //                         className: 'input-project-code'
        //                     }
        //                 ]
        //
        //             },
        //             cont_comp: {
        //                 internalModelName: 'cont_comp',
        //                 externalModelName: 'vendor',
        //                 refreshType: 'vendors',
        //                 displayName: "Vendors",
        //                 filters: {
        //                     readyToImport: {
        //                         displayName: 'Ready to Import',
        //                         name: 'readyToImport',
        //                     },
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '#{0,10}',
        //                         className: 'input-vendor-number'
        //                     }
        //                 ]
        //             },
        //             budget: {
        //                 internalModelName: 'budget',
        //                 displayName: "Budget",
        //                 externalModelName: 'estimate',
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: []
        //             },
        //             commitment: {
        //                 internalModelName: 'commitment',
        //                 externalModelName: 'commitment',
        //                 displayName: "Commitments",
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '99999',
        //                         className: 'input-commitment-number'
        //                     }
        //                 ]
        //             },
        //             cco: {
        //                 internalModelName: 'cco',
        //                 externalModelName: 'cco',
        //                 displayName: "Commitment Change Orders",
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         format: '9999',
        //                         required: true,
        //                         className: 'input-cco-number'
        //                     }
        //                 ]
        //             },
        //             ap_inv: {
        //                 internalModelName: 'ap_inv',
        //                 externalModelName: 'ap_inv',
        //                 displayName: "Payable Invoices",
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '*{0,5}',
        //                         className: 'input-payable-invoice-number'
        //                     },
        //                     {
        //                         type: 'date',
        //                         name: 'Approval Date',
        //                         value: 'approvalDate',
        //                         required: false,
        //                         className: 'input-payable-invoice-approval-date'
        //                     }
        //                 ]
        //             },
        //             pcco: {
        //                 internalModelName: 'pcco',
        //                 externalModelName: 'pcco',
        //                 displayName: "Contract Change Orders",
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '9999',
        //                         className: 'input-pcco-number'
        //                     }
        //                 ]
        //             },
        //         }
        //     }
        // },
    },
    erp: {
        syncStatuses: {
            STALE: -2,
            CACHED: -1,
            PENDING: 0,
            REVIEWING: 1,
            REJECTED: 2,
            APPROVED: 3,
            SYNCED: 4,
            FAILED: 5,
            ARCHIVED: 6
        },
        syncStatusDescriptions: {
            '-2': 'Changes were made which have not been synced to your ERP system',
            0: 'ERP sync not started',
            1: 'ERP sync waiting for approval',
            2: 'ERP sync rejected',
            3: 'Approved - Sync to ERP in process',
            4: 'Synced to ERP',
            5: 'Sync to ERP failed',
            6: 'Archived'
        }
    }
};


//Models
PJQ.integrations.models.Integration = PJQ.models.BaseModel.extend({
    idAttribute: "id",
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let endpointArr,
            params = [];
        if (this.id > 0) {

            params.push({
                parameter: 'erp',
                value: this.get('erp')
            });

            endpointArr = [
                {
                    endpoint: 'integrations',
                    value: this.get('name')
                }
            ];
        } else {
            if (this.options.erp) {
                params.push({
                    parameter: 'erp',
                    value: true
                });

                if (_.size(this.get("name")) === 0) {
                    this.set('name', 'default');
                }
            }

            endpointArr = [
                {
                    endpoint: 'integrations',
                    value: this.get('name')
                }
            ];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr, params);
    },
    parse: function (model) {
        if (model == null) {
            model = {};
        }

        if (!model.settings) {
            model.settings = {};
        }
        return model;
    },
    getSetting: function (setting) {
        return this.attributes.settings ? this.attributes.settings[setting] : null;
    },
    setSetting: function (setting, value) {
        if (_.size(setting) === 0) {
            return false;
        }

        if (this.attributes.settings == null) {
            this.attributes.settings = {};
        }
        this.attributes.settings[setting] = value;
        return true;
    },
    undoPush: function (obj, callback) {
        let externalObj = obj.get('externalObject');
        if (externalObj == null || !(externalObj.id > 0) || externalObj.status !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            if (typeof callback === 'function') {
                callback(obj);
            }
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'objects',
                    value: externalObj.id
                },
                {
                    endpoint: 'undopush'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            obj.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(obj);
            }
        }).fail(function () {
            // todo: error
        });
    },
    fetchSyncData: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.syncData != null) {
                if (typeof callback === 'function') {
                    callback(this.syncData);
                }
                resolve(this.syncData);
                return;
            }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'syncdata'
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                this.syncData = res;
                if (typeof callback === 'function') {
                    callback(this.syncData);
                }
                resolve(this.syncData);
            }).fail(() => {
                reject(new Error("Failed to fetch erp integration sync data"));
            });
        });
    },
    fetchSettingsData: function (callback, options = null) {
        this.settingsData = {};
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'settingsdata'
                    }
                ], [
                    {
                        parameter: 'type',
                        value: options ? options.type : null
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                this.settingsData = _.extend(this.settingsData, res ?? {});
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }).fail((res) => {
                if (!this.handleError(res)) {
                    reject(res);
                }
            });
        });
    },
    pushVendor: function (contact, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'vendors',
                    value: contact.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            contact.set({
                companyExternalObject: res,
                externalObject: res
            }, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(contact);
            }
        }).fail(function () {
            // todo: error
        });
    },
    unlinkVendor: function (contactCompany, callback) {
        let contactCompanyId = contactCompany.get('contactCompanyId');
        if (contactCompanyId == null) {
            contactCompanyId = contactCompany.id;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'vendors',
                    value: contactCompanyId
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            contactCompany.set({
                companyExternalObject: null,
                externalObject: null
            }, null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((xhr) => {
            // todo: error
        });
    },
    fetchUnlinkedProjects: async function () {
        return await this.fetchProjects(false);
    },
    fetchLinkedProjects: async function () {
        return await this.fetchProjects(true);
    },
    fetchProjects: async function (synced = false) {
        return new Promise((resolve, reject) => {
            if (this.erpProjects == null) {
                this.erpProjects = {};
            }

            let result = this.erpProjects[synced];
            if (result != null) {
                resolve(result);
                return;
            }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'projects'
                    }
                ], [{
                    parameter: 'synced',
                    value: synced
                }]),
                isAPIv2: true
            }).get().done((res) => {
                this.erpProjects[synced] = res;
                resolve(this.erpProjects[synced]);
            }).fail(() => {
                reject(new Error("Failed to fetch erp projects"));
            });
        });
    },
    pushProject: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            project.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(project);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    linkProject: function (project, externalId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'link'
                }
            ], [{
                parameter: 'externalId',
                value: externalId
            }]),
            isAPIv2: true
        }).post().done((res) => {
            project.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(project);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkProject: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            project.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushSubJobs: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'subjobs'
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullSubJobs: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'subjobs'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    updateCostTypeData: function (obj, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costtypes'
                },
                {
                    endpoint: 'data'
                }
            ]),
            isAPIv2: true,
            data: obj
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushCostTypes: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costtypes'
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullCostTypes: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costtypes'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushCostCodes: function (options, callback) {
        let params = [];
        if (options) {
            if (options.project && options.project.id > 0) {
                params.push({
                    parameter: 'projectId',
                    value: options.project.id
                });
            }

            if (options.dryRun) {
                params.push({
                    parameter: 'dryRun',
                    value: true
                });
            }
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costcodes'
                },
                {
                    endpoint: 'push'
                }
            ], params),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullCostCodes: function (project, callback) {
        let params = [];
        if (project != null) {
            params.push({
                parameter: 'projectId',
                value: project ? project.id : null
            });
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costcodes'
                },
                {
                    endpoint: 'pull'
                }
            ], params),
            isAPIv2: true,
            data: []
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    fetchCostCodes: function (callback, options = null) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costcodes'
                }
            ], [
                {
                    parameter: 'forLinking',
                    value: options && options.forLinking ? true : null
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullTaxCodes: function (project, callback) {
        let params = [];
        if (project != null) {
            params.push({
                parameter: 'projectId',
                value: project ? project.id : null
            });
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'taxcodes'
                },
                {
                    endpoint: 'pull'
                }
            ], params),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushBudget: function (budget, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: budget.get('projectId')
                },
                {
                    endpoint: 'budget'
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            budget.set({
                externalObject: res,
                isLocked: true
            }, {
                silent: true
            })
            budget.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(budget);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullBudget: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'budget'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushCommitment: function (commitment, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitments',
                    value: commitment.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            commitment.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(commitment);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullCommitments: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'commitments'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkCommitment: function (commitment, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitments',
                    value: commitment.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            commitment.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushChangeRequest: function (changeRequest, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'changerequests',
                    value: changeRequest.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            changeRequest.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(changeRequest);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkChangeRequest: function (changeRequest, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'changerequests',
                    value: changeRequest.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            changeRequest.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushCommitmentChangeOrder: function (changeOrder, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitmentchangeorders',
                    value: changeOrder.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            changeOrder.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(changeOrder);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullCommitmentChangeOrders: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'commitmentchangeorders'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkCommitmentChangeOrder: function (changeOrder, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitmentchangeorders',
                    value: changeOrder.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            changeOrder.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushPrimeContract: function (primeContract, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'primecontracts',
                    value: primeContract.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            primeContract.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(primeContract);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullPrimeContracts: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'primecontracts'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkPrimeContract: function (contract, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'primecontracts',
                    value: contract.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            contract.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushPrimeContractChangeOrder: function (changeOrder, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'primecontractchangeorders',
                    value: changeOrder.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            changeOrder.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(changeOrder);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullPrimeContractChangeOrders: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'primecontractchangeorders'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkPrimeContractChangeOrder: function (changeOrder, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'primecontractchangeorders',
                    value: changeOrder.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            changeOrder.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushDirectCost: function (directcost, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'directcosts',
                    value: directcost.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            directcost.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(directcost);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullDirectCosts: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'directcosts'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkDirectCost: function (directCost, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'directcosts',
                    value: directCost.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            directCost.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushPayableInvoice: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'payableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            invoice.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(invoice);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullPayableInvoicePayments: function (invoice, callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'payableinvoicepayments',
                        value: invoice.id
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }).fail((err) => {
                if (typeof callback === 'function') {
                    callback(null, err);
                }
                this.handleError(err);
                reject(new Error("Failed to fetch invoice payments"));
            });
        });
    },
    unlinkPayableInvoice: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'payableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            invoice.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushReceivableInvoice: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'receivableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            invoice.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(invoice);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullReceivableInvoicePayments: function (invoice, callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'receivableinvoicepayments',
                        value: invoice.id
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }).fail((err) => {
                if (typeof callback === 'function') {
                    callback(null, err);
                }
                this.handleError(err);
                reject(new Error("Failed to fetch invoice payments"));
            });
        });
    },
    unlinkReceivableInvoice: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'receivableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            invoice.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    getProvider: function () {
        return PJQ.constants.integrations.providers[this.get('name')];
    },
    getShortName: function () {
        let pvd = this.getProvider();
        if (pvd != null) {
            return _.size(pvd.shortName) > 0 ? pvd.shortName : '';
        }
        return '';
    },
    getBudgetColumns: function () {
        let pvd = this.getProvider();
        if (pvd != null) {
            return pvd.budgetColumns != null ? pvd.budgetColumns : [];
        }
        return [];
    },
    hasAvailableAction: function (action) {
        let pvd = this.getProvider();
        if (pvd != null) {
            return pvd.availableActions != null && pvd.availableActions.indexOf(action) !== -1;
        }
        return false;
    },
    authorize: function () {
        return new Promise((resolve, reject) => {
            let type = this.get('name'),
                provider = PJQ.constants.integrations.providers[type];
            if (provider && provider.isAgave) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'integrations'
                        },
                        {
                            endpoint: 'agave'
                        },
                        {
                            endpoint: 'linktoken'
                        }
                    ], [
                        {
                            parameter: 'name',
                            value: type
                        }
                    ]),
                    isAPIv2: true
                }).get().done((response) => {
                    if (_.size(response.linkToken) > 0) {
                        window.AgaveLink.openLink({
                            linkToken: response.linkToken,
                            sourceSystem: provider.agaveSourceSystem,
                            showSandboxSourceSystems: true,
                            onSuccess: (publicToken) => {
                                this.get('settings').publicToken = publicToken;
                                resolve(true);
                            }
                        });
                    } else {
                        reject(new Error('Failed to get Agave link token'));
                    }
                }).fail(function (err) {
                    reject(err)
                });
                return;
            }

            switch (type) {
                case PJQ.constants.integrations.providers.ACUMATICA.name:
                case PJQ.constants.integrations.providers.SAGE100.name:
                case PJQ.constants.integrations.providers.SAGE300.name:
                case PJQ.constants.integrations.providers.INTACCT.name:
                    resolve(true);
                    break;
                case PJQ.constants.integrations.providers.QBO.name:
                default:
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'integrations'
                            },
                            {
                                endpoint: 'authorize'
                            }
                        ], [
                            {
                                parameter: 'name',
                                value: type
                            }
                        ]),
                        isAPIv2: true
                    }).get().done((response) => {
                        document.location = response.url;
                        resolve(true);
                    }).fail(function (res) {
                        reject(res);
                    });
                    break;
            }
        });
    },
    handleError: function (res) {
        // if this function returns true, the error was handled
        // if it returns false, the error was not handled and the caller is expected to handle it
        // this is used to handle errors that are common to all ERP integrations - i.e. authentication for QBO
        if (res && res.responseJSON && res.responseJSON.type === "APP_NOT_AUTHORIZED" && this.get('name') === PJQ.constants.integrations.providers.QBO.name) {
            new PJQ.views.modals.YesNo({
                header: "Authorize QuickBooks Online",
                body: "Authorization for QuickBooks Online has expired. You must re-authorize to continue to use the integration features. Would you like to re-authorize now?",
                onYes: () => {
                    this.authorize().catch((err) => {

                    });
                }
            });
            return true;
        }
        return false;
    }
});

// Collections
PJQ.integrations.collections.Integrations = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.integrations.models.Integration,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'integrations'
            }
        ]);
    }
});

// Models
PJQ.integrations.models.LinkERPProjectModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-erp-project-link'),
        onCancel: _.noop,
        onSave: _.noop,
        minWidth: '700px'
    },
    events: {
        "change .select-project": "selectProject",
        "click .btn-cancel": "cancel",
        "click .btn-save": "save"
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        this.provider = this.erpIntegration.getProvider();

        this.projects = await this.erpIntegration.fetchUnlinkedProjects();

        this.isFetched = true;

        this.render();
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            provider: this.provider
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        let columns = [
            {
                "data": "id",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": (data, type, row) => {
                    let isSelected = this.selectedProject && this.selectedProject.id === row.id;
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (isSelected ? ' checked ' : '') + ' class="select-project"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }
            },
            {
                "data": "name",
                "title": "Name",
                "render": (data, type, row) => {
                    return row.data.name ?? "";
                }
            },
            {
                "data": "city",
                "title": "City",
                "render": (data, type, row) => {
                    return row.data.city ?? "";
                }
            },
            {
                "data": "state",
                "title": "State",
                "render": (data, type, row) => {
                    return row.data.state ?? "";
                }
            }];
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.projects-data-table'),
            data: this.projects,
            deferRender: true,
            order: [1, 'asc'],
            columns: columns,
            language: {
                emptyTable: "No projects were found",
                zeroRecords: "No projects match the search criteria"
            }
        });
    },
    selectProject: function (e) {
        let target = $(e.currentTarget),
            isSelected = target.prop('checked');
        this.$('.select-project').not(target).prop('checked', false);
        if (isSelected) {
            this.selectedProject = this.dataTable.dataTable.row(target.parents('tr')).data();
        } else {
            this.selectedProject = null;
        }
        this.$('.btn-save').prop('disabled', this.selectedProject == null)
    },
    save: function () {
        if (this.options.project != null && this.selectedProject != null && _.size(this.selectedProject.externalId) > 0) {
            this.erpIntegration.linkProject(this.options.project, this.selectedProject.externalId, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Project linked to ERP'
                });
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.options.project);
                }
            });
        }

        this.removeModal();
    },
    cancel: function () {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
        }
    }
});